import React from 'react';
import GradientStrip from '../gradientStrip';
import logo from '../../assets/logos/logo.png';
import footerLogo from '../../assets/logos/footerLogos.png';

const AdminBrandLayout = ({ children }) => (
  <div className="min-h-screen supports-[min-height:100dvh]:min-h-dvh flex flex-col bg-white">
    <GradientStrip height="36px" />
    <header className="w-[calc(100%-48px)] max-w-[1530px] mx-auto pt-[clamp(40px,5.26vw,98px)]">
      <img
        src={logo}
        alt="ORIENT’EST — La Région Grand Est"
        className="block w-full max-w-[620px] h-auto"
      />
    </header>
    <main className="flex-1 flex items-center justify-center py-[64px] px-[24px]">{children}</main>
    <footer className="flex items-center justify-center min-h-[132px] md:min-h-[188px] p-[24px] border-t border-gray-50 bg-gray-70">
      <img
        src={footerLogo}
        alt="Financé par l’Union européenne — WorldSkills France — La Région Grand Est"
        className="block w-full max-w-[476px] h-auto"
      />
    </footer>
  </div>
);

export default AdminBrandLayout;
